import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      header: {
        flex: '0 0 auto',
        overflow: 'hidden',
        position: 'relative',
      },

      subtitle: {
        ...tokens.fontBodyM,
        color: tokens.fontColorDefault,
        marginBottom: 0,
        marginTop: '8px',
      },
    },
  } as const
}
